module.exports = __webpack_public_path__ + "static/media/logo_gray_icon.10cade0d.svg";